import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GameManager = _resolveComponent("GameManager")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("div", null, [
      _createElementVNode("h1", null, "Mars Rover Mission"),
      _createElementVNode("p", { class: "byMe" }, "By: Raul Segui Tejeda")
    ], -1)),
    _createVNode(_component_GameManager)
  ], 64))
}